import { useAnchorable } from '../../hooks/useAnchorable';

import {
  boostContainer,
  boostContentContainer,
  boostInnerContainer,
  button,
  content,
  image,
  imageContainer,
  sponsored,
  subtitle,
} from './Boost.css';
import type { TPostBoostProps } from './Boost.types';

export const PostBoost = (props: TPostBoostProps) => {
  const { element, translations, rewriteImageSrc, isIndexingDisabled } = props;
  const { attrs } = element;
  const { anchorAttributes } = useAnchorable(attrs);

  if (!attrs?.data?.recommended_publication) {
    return null;
  }

  const { recommended_publication: recommendedPublication } = attrs.data;

  const logoUrl =
    recommendedPublication?.logo_url && rewriteImageSrc
      ? rewriteImageSrc(recommendedPublication?.logo_url)
      : recommendedPublication?.logo_url;

  return (
    <div {...anchorAttributes} className={boostContainer}>
      <div className={boostInnerContainer}>
        <div className={boostContentContainer}>
          <div className={imageContainer}>
            <img alt={recommendedPublication?.name} src={logoUrl} className={image} />
          </div>
          <div className={content}>
            <p className={sponsored}>Sponsored</p>
            <p>{recommendedPublication?.name}</p>
            <p className={subtitle}>{recommendedPublication?.description}</p>
          </div>
        </div>
        <a
          href={recommendedPublication?.subscribe_url}
          rel={isIndexingDisabled ? 'nofollow noopener' : undefined}
          className={button}
          target="_blank"
          data-skip-tracking="true"
        >
          {translations?.['shared.cta.subscribe']}
        </a>
      </div>
    </div>
  );
};
